import { useEffect, useState } from 'react'
import { Spinner } from 'components'
import { useTranslation } from 'react-i18next'
import StatCard from 'components/AdminCards/StatCard'
import { getDashboard } from 'service/AdminPanelService'
import styles from '../AdminFullPage.module.scss'

function formatDate(value) {
  if (!value) return ''
  try {
    const d = new Date(value)
    if (Number.isNaN(d.getTime())) return String(value)
    return d.toLocaleString('ru-RU')
  } catch (e) {
    return String(value)
  }
}

function DashboardTab() {
  const { t } = useTranslation('common')
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    getDashboard()
      .then((res) => setData(res?.data || res || null))
      .catch(() => setData(null))
      .finally(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <div className={styles.spinner_box}>
        <Spinner.Center />
      </div>
    )
  }

  const students = data?.students || {}
  const accounting = data?.accounting || {}
  const recent = Array.isArray(data?.recent_activity) ? data.recent_activity : []

  return (
    <div>
      <h2 className={styles.section_title}>{t('admin.fullPage.dashboard_title')}</h2>

      <div className={styles.cards_grid}>
        <StatCard icon="ПЛ" title={t('admin.fullPage.dashboard_users_total')} value={data?.users_total} />
        <StatCard icon="СТ" title={t('admin.fullPage.dashboard_students')} value={students.total} />
        <StatCard icon="АК" title={t('admin.fullPage.dashboard_active_students')} value={students.active} />
        <StatCard icon="СО" title={t('admin.fullPage.dashboard_employees')} value={data?.employees_total} />
        <StatCard icon="ПС" title={t('admin.fullPage.dashboard_lessons_today')} value={data?.lessons_today} />
        <StatCard icon="ВД" title={t('admin.fullPage.dashboard_statements_open')} value={data?.statements_open} />
        <StatCard
          icon="ПМ"
          title={t('admin.fullPage.dashboard_income_month')}
          value={accounting.income_records_month}
        />
        <StatCard
          icon="РМ"
          title={t('admin.fullPage.dashboard_expense_month')}
          value={accounting.expense_records_month}
        />
      </div>

      {students.by_status ? (
        <div className={styles.subsection}>
          <h3 className={styles.section_title}>{t('admin.fullPage.dashboard_students_by_status')}</h3>
          <table className="unv-table">
            <thead>
              <tr>
                <th>{t('admin.fullPage.dashboard_th_status')}</th>
                <th>{t('admin.fullPage.dashboard_th_count')}</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(students.by_status).map(([k, v]) => (
                <tr key={k}>
                  <td>{k}</td>
                  <td>{v}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}

      <h3 className={styles.section_title}>{t('admin.fullPage.dashboard_recent_activity')}</h3>
      {recent.length === 0 ? (
        <div className="unv-empty">{t('admin.fullPage.dashboard_no_records')}</div>
      ) : (
        <table className="unv-table">
          <thead>
            <tr>
              <th>{t('admin.fullPage.audit_th_when')}</th>
              <th>{t('admin.fullPage.audit_th_who')}</th>
              <th>{t('admin.fullPage.audit_th_action')}</th>
              <th>{t('admin.fullPage.audit_th_module')}</th>
              <th>{t('admin.fullPage.audit_th_object')}</th>
            </tr>
          </thead>
          <tbody>
            {recent.map((row, i) => (
              <tr key={row.id || i}>
                <td>{formatDate(row.created_at || row.timestamp)}</td>
                <td>{row.actor_username || row.actor || '—'}</td>
                <td>{row.action || '—'}</td>
                <td>{row.module || '—'}</td>
                <td>{row.target_repr || row.target || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export default DashboardTab
